import { FAULT_TYPES } from '../constants/protocol';

const SSR_FAULT_TYPES = [FAULT_TYPES.SSR, FAULT_TYPES.SSR_OVER_CURRENT];

export const isSsrFaultType = (faultType) => SSR_FAULT_TYPES.includes(faultType);

export const isResetBlockedBySsr = (faultType, ssrRecord) =>
  faultType === FAULT_TYPES.SSR && ssrRecord?.reset === 0;

// Force (max heat for 12 h / 3 days) only applies to a thermocouple.
export const showsForceButton = (faultType) => faultType === FAULT_TYPES.THERMOCOUPLE;
